<template>
  <div class="opple-jimudan">
    <div>{{ $t('projectmsg.playlistInformation') }}</div>
    <div class="opple-jimudan_ipts-container">
      <div class="opple-jimudan_ipts">
        <el-upload
          class="upload-box"
          action="/api/StatisticalAnalysis/ImportLightBoxConfig"
          :limit="1"
          :show-file-list="false"
          :before-upload="beforeProjectUpload"
        >
          <el-button style="margin-left: 5%" class="el-icon-upload2">
            {{ $t("base.import") }}
          </el-button>
        </el-upload>
        <el-button
          style="margin-left: 5%"
          class="el-icon-download"
          @click="doExportProgram"
        >
          {{ $t("base.export") }}
        </el-button>
        <el-button
          style="margin-left: 5%"
          class="el-icon-download"
          @click="deleteProgram"
        >
          {{ $t("sync.delete") }}
        </el-button>
      </div>
      <div v-if="isShowImportError" class="error-file-tip">
        {{ $t("projectmsg.errorFileTip") }}
      </div>
    </div>
  </div>
</template>
<script>
import {
  ImportProgram,
  ExportProgram,
  ImportGatewayProgramListConfig,
  ExportGatewayProgramListConfig,
  DeleteGatewayProgramListConfig
} from "@/axios/IProject.js";
import moment from "moment";
import { alerterror, alertsuccess } from "@/assets/js/common.js";

export default {
  props: {
    vDeviceId: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      projectFileList: null,
      isShowImportError: false,
    }
  },
  watch: {
    data: {
    }
  },
  created() {},
  mounted() {
   
  },
  methods: {
    beforeProjectUpload(file){
      this.projectFileList = file;

      const isJSON = file.type === 'application/json';

      if (!isJSON) {
        this.isShowImportError = true;
        return false;
      };

      this.isShowImportError = false;

      const reader = new FileReader();

      reader.readAsText(file, 'UTF-8'); //读取文件
      reader.onload = (e) => {
        try {
          let fileContent = JSON.parse(e.target.result);
  
          if (typeof fileContent !== 'object' || fileContent === null) {
            throw new Error('文件内容不是 JSON 形式');
          };

          ImportGatewayProgramListConfig({
            ProjectCode: this.$store.state.projectcode,
            Content: JSON.stringify(fileContent),
            vDeviceId: this.vDeviceId,
          }, (res) => {
            if (res.StatusCode == 0) {
              alertsuccess(this, res.StatusCode);
            } else {
              alerterror(this, res.StatusCode);
            };
          });
        } catch (error) {
          this.$message.error(this.$t('projectmsg.JSONOnly'));
        }
      }
      return false; // 阻止组件默认的上传行为，因为我们自己处理了上传
    },

    doExportProgram(){
      ExportGatewayProgramListConfig({ vDeviceId: this.vDeviceId }, (res) => {
        if (res.StatusCode == 0) {
          const { Result } = res;
          let now = moment().format("YYYYMMDDHHMMSS");
          this.handleDownloadFile(Result, `${now}.json`);
        } else {
          alerterror(this, res.StatusCode);
        }
      });
    },

    handleDownloadFile(fileData, fileName) {
      const data = window.atob(fileData); //下载的文件流
      const aBuffer = new window.ArrayBuffer(data.length);
      const uBuffer = new window.Uint8Array(aBuffer);
      for (let i = 0; i < data.length; i++) {
        uBuffer[i] = data.charCodeAt(i) & 0xff;
      }
      const blob = new Blob([uBuffer]);
      const url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = url;
      link.download = fileName;
      document.body.append(link);
      link.click();
      link.remove();
    },

    deleteProgram() {
      DeleteGatewayProgramListConfig({vDeviceId: this.vDeviceId}, (res) => {
        if (res.StatusCode == 0) {
          alertsuccess(this, res.StatusCode);
        } else {
          alerterror(this, res.StatusCode);
        };
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.opple-jimudan {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 20px 10px;
  border: 1px solid #e0e3e6;

  .opple-jimudan_ipts-container {
    height: 58px;
    transform: translateY(8px);

  }

  .opple-jimudan_ipts {
    display: flex;
    margin-right: 20px;
  }

  .error-file-tip {
    margin-top: 5px;
    color: red;
    text-align: right;
  }
}
</style>
